import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) =>({
    progressBarBox: {
        width: 400,
        '& .MuiBox-root': {
            padding: 0,
            marginBottom: 8,
            display: 'flex',
            justifyContent: 'flex-end',
        },
        '& .MuiButtonBase-root': {
            padding: 0,
        }
    },
    progressBar: {
        '&.MuiLinearProgress-root': {
            height: 20,
            width: 400,
            borderRadius: '25px',
        },
        '& .MuiLinearProgress-barColorPrimary': {
            background: '#5579f0',
            borderRadius: '25px',
        },
        '&.MuiLinearProgress-colorPrimary': {
            background: '#d7d7d7',
        }
    },
    barState: {
        display: 'flex',
        justifyContent: 'flex-end',
        '& .MuiTypography-root': {
            marginTop: 5,
            color: '#5579f0',
            fontSize: '0.875rem',
            letterSpacing: '-0.5px',
        }
    },
    uploadText: {
        textAlign: 'center',
        fontSize: '1.063rem',
        color: '#10121c',
        letterSpacing: '-0.5px',
        marginTop: 40,
    },
    uploadData: {
        '&.MuiBox-root': {
            display: 'flex',
            justifyContent: 'flex-start',
            '& .MuiTypography-root': {
                color: '#87888d',
                fontSize: '0.813rem',
                letterSpacing: '-0.5px',
            }
        }
    },
}))
